import React from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import Page21 from './pages/Page2-1';
import Page22 from './pages/Page2-2';
import Page3 from './pages/Page3';
import Page4 from './pages/Page4';
import Page5 from './pages/Page5';
import Page3_1_PT from './pages/Page3-1-PT';
import Page3_1_EN from './pages/Page3-1-EN';
import Page3_1_ES from './pages/Page3-1-ES';
import Page3_2 from './pages/Page3-2';
import Page5_1 from './pages/Page5-1';
import Page5_2 from './pages/Page5-2';
import './App.css';

function Home() {
  return (
    <div>
      <nav>
        <ul>
          <li><Link to="/page1">Screen 1</Link></li>
          <li><Link to="/page2">Screen 2</Link></li>
          <li><Link to="/page3">Screen 3</Link></li>
          <li><Link to="/page4">Screen 4</Link></li>
          <li><Link to="/page5">Screen 5</Link></li>
        </ul>
      </nav>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/page1" element={<Page1 />} />
          <Route path="/page2" element={<Page2 />} />
          <Route path="/page2-1" element={<Page21 />} />
          <Route path="/page2-2" element={<Page22 />} />
          <Route path="/page3" element={<Page3 />} />
          <Route path="/page3-1-PT" element={<Page3_1_PT />} />
          <Route path="/page3-1-EN" element={<Page3_1_EN />} />
          <Route path="/page3-1-ES" element={<Page3_1_ES />} />
          <Route path="/page3-2" element={<Page3_2 />} />
          <Route path="/page4" element={<Page4 />} />
          <Route path="/page5" element={<Page5 />} />
          <Route path="/page5-1" element={<Page5_1 />} />
          <Route path="/page5-2" element={<Page5_2 />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
